module.exports = __webpack_public_path__ + "img/project-overview-billing-dangeour.b04e1ece.svg";